import { ua } from './ua';
import { isAndroid, isIos } from './system';
import { isUmuWx } from './umu';

/**
 * 是否飞书桌面版
 * [手机端]Mozilla/5.0 (Linux; Android 9; MI 6X Build/PKQ1.180904.001; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/75.0.3770.156 Mobile Safari/537.36 Lark/5.10.4 LarkLocale/zh_CN ChannelName/Feishu TTWebView/0751130016452
 * [桌面端]Mozilla/5.0 (Macintosh; Intel Mac OS X 11_6_1) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/101.0.4951.53 Safari/537.36 Lark/5.32.6 LarkLocale/zh_CN Electron/Native WebApp/workplace
 */
export const isFeishu = /Lark/i.test(ua) || /Feishu/i.test(ua);
export const isFeiShuMobile = isFeishu && /Mobile/i.test(ua);
export const isFeiShuDesktop = /Electron/i.test(ua) && (/Lark/i.test(ua) || /Feishu/i.test(ua));
/**
 * 是否在钉钉桌面版 Web环境内
 */
export const isDingdingDesktop = !/AliApp/i.test(ua) && /DingTalk/i.test(ua);

/**
 * 是否移动端
 */
export const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua) ||
    (navigator.platform === 'MacIntel' && (navigator.maxTouchPoints > 1 || 'ontouchstart' in window)) ||
    isDingdingDesktop; // iPadOS13

/**
 * 是否桌面端浏览器
 */
export const isDesktop = !isMobile || isDingdingDesktop;

/**
 * 是否在钉钉App Web环境内
 */
export const isDingding = /AliApp/i.test(ua) && /DingTalk/i.test(ua);

/**
 * 是否为QQ App内Web浏览器
 */
export const isQQ = /TBS/i.test(ua);

/**
 * 是否为iOS平台下的
 */
export const isIosQQ = isIos && / QQ/i.test(ua);

/**
 * 是否为QQ浏览器
 */
export const isQQBrowser = /QQBrowser/i.test(ua);

/**
 * 是否为Safari浏览器
 */
export const isSafari = /Safari/i.test(ua) && !/Chrome/i.test(ua);

/**
 * 是否为Sogou浏览器
 */
export const isSogou = /MetaSr/i.test(ua);

/**
 * 是否为Samsung浏览器
 */
export const isSamsungBrowser = /SamsungBrowser/i.test(ua);

/**
 * 是否为小米浏览器
 */
export const isMiuiBrowser = /MiuiBrowser/i.test(ua);

/**
 * 是否为Chrome浏览器
 */
export const isChrome = /Chrome/i.test(ua);

/**
 * 是否为iOS上的Chrome浏览器
 */
export const isCriOS = /CriOS/i.test(ua);

/**
 * 是否为Edge浏览器【Chrome内核】
 */
export const isChromeBasedEdge = /edg\//i.test(ua);

/**
 * 获取Chrome浏览器版本
 * @returns Chrome浏览器版本号
 */
export const getChromeVersion = () => {
    var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);

    return raw ? parseInt(raw[2], 10) : false;
}

export const chromeVersion = getChromeVersion();

/**
 * 是否移动端Web浏览器
 */
export const isMobileBrowser = !isUmuWx && (isAndroid || isIos);

/**
 * 是否为 IE 10 及以下
 */
export const isIE = /MSIE/i.test(ua);

/**
 * 是否为IE 11 及以下
 */
export const isFullIE = isIE || /trident/i.test(ua);

/**
 * @description: 是否为 Firefox 浏览器
 */

export const isFirefox = ua.indexOf('firefox') > -1;

/**
 * 获取IE浏览器版本
 * @returns Edge: 12 / IE11: 11 / 低于IE11版本: -1
 */
export const getIEVersion = (): number => {
    const userAgent = navigator.userAgent;
    const isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1;
    const isEdge = userAgent.indexOf('Edge') > -1 && !isIE;
    const isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1;
    if (isIE) {
        const match = userAgent.match(/MSIE (\d+)\.\d+;/i);
        if (!match || match.length < 2) {
            return -1;
        }
        const version = parseInt(match[1], 10);
        return version;
    } else if (isEdge) {
        return 12;
    } else if (isIE11) {
        return 11;
    } else {
        return -1;
    }
};


export function getBrowserName() {
    const ua = navigator.userAgent.toLowerCase();

    if (ua.indexOf('opera') > -1 || ua.indexOf('opr') > -1) {
        return 'Opera';
    } else if (ua.indexOf('compatible') > -1 && ua.indexOf('msie') > -1) {
        return 'IE';
    } else if (ua.indexOf('edge') > -1 || ua.indexOf('edg') > -1) {
        return 'Edge';
    } else if (ua.indexOf('firefox') > -1) {
        return 'Firefox';
    } else if (ua.indexOf('safari') > -1 && ua.indexOf('chrome') == -1) {
        return 'Safari';
    } else if (ua.indexOf('chrome') > -1 && ua.indexOf('safari') > -1) {
        return 'Chrome';
    } else if (ua.indexOf('qqbrowser') > -1) {
        return 'QQBrowser';
    } else if (ua.indexOf('metasr') > -1) {
        return 'SogouBrowser';
    } else if (ua.indexOf('samsungbrowser') > -1) {
        return 'SamsungBrowser';
    } else if (ua.indexOf('miuibrowser') > -1) {
        return 'MiuiBrowser';
    } else {
        return '';
    }
}


export function normalizeVersion(version: number | string) {
    if (typeof version === 'number') {
        return `${version}.0.0`;
    }
    return version;
}

export function getBrowserVersion(browser: string) {
    let match = null;
    const defaultVersion = '0.0.0';
    const ua = navigator.userAgent.toLowerCase();

    switch (browser) {
        case 'safari':
            match = ua.match(/version\/([\d\.]+).*safari/);
            return match ? match?.[1] : defaultVersion;
        case 'chrome':
            match = ua.match(/chrom(e|ium)\/(\d+)\./);
            const version = match ? parseInt(match?.[2], 10) : defaultVersion;
            return normalizeVersion(version);
        case 'firefox':
            match = ua.match(/firefox\/([\d\.]+)/);
            return match ? match?.[1] : defaultVersion;
        case 'edge':
            match = ua.match(/edge?\/([\d\.]+)/);
            return match ? match?.[1] : defaultVersion;
        case 'ie':
            if (ua.indexOf('trident') > -1 && ua.indexOf('rv:11.0') > -1) {
                return '11.0.0';
            } else if (ua.indexOf('msie')) {
                return '10.0.0';
            }
            return defaultVersion;
        case 'opera':
            match = ua.match(/(?:opera|opr).([\d\.]+)/);
            return match ? match?.[1] : defaultVersion;
        default:
            return defaultVersion;
    }
}

export function getBrowserType() {
    return isMobile ? 'mobile' : 'pc';
}

export function compareBrowserVersion(version1: string, version2: string) {
    const v1 = version1.split('.');
    const v2 = version2.split('.');
    for (let i = 0; i < v1.length || i < v2.length; i++) {
        let x = 0;
        let y = 0;
        if (i < v1.length) {
            x = parseInt(v1[i]);
        }
        if (i < v2.length) {
            y = parseInt(v2[i]);
        }
        if (x > y) {
            return 1;
        }
        if (x < y) {
            return -1;
        }
    }
    return 0;
}

export function isInMicroApp() {
    return !!(window as any).microApp;
}

export function MicroAppInstance() {
    return (window as any).microApp;
}
